/**
* The app component rendered here determines weather this project produces the PMN Data Gateway or nowCOAST
*   For PMN Data Gateway viewer:
*     uncomment the render containing PNGatewayApp as well as its related imports (app and theme)
*  For nowCOAST:
*     uncomment the render containing NowCoastApp as well as its related imports (app and theme)
*/
import React from 'react';
import {createRoot} from "react-dom/client";
import { ThemeProvider as StyledThemeProvider } from '@mui/material';

//// Imports for PMN Data Gateway (uncomment to use PMN Data Gateway)
//import PNGatewayApp from './map-viewer/apps/precision-nav/app.js';
//import theme from "./map-viewer/apps/precision-nav/theme.js";

// Imports for nowCOAST (uncomment to use nowCOAST)
import NCMapViewerApp from './map-viewer/apps/nowcoast/app.js';
import theme from "./map-viewer/apps/nowcoast/theme.js";


// Note: strict mode should be applied during development; it helps identify potential issues. More info at https://reactjs.org/docs/strict-mode.html

const container = document.getElementById('root');
const root = createRoot(container);

// Render for PMN Data Gateway (uncomment to use PMN Data Gateway)
//root.render(
//    <StyledThemeProvider theme={theme}>
//        <PNGatewayApp />
//    </StyledThemeProvider>,
//);

// Only uncomment for development as alternative to the render above without strict mode
//root.render(
//    <React.StrictMode>
//        <StyledThemeProvider theme={theme}>
//            <PNGatewayApp />
//        </StyledThemeProvider>
//    </React.StrictMode>,
//);

// Render for nowCOAST (uncomment to use nowCOAST)
root.render(
    <StyledThemeProvider theme={theme}>
        <NCMapViewerApp />
    </StyledThemeProvider>,
);

// Only uncomment for development as alternative to the render above without strict mode
//root.render(
//    <React.StrictMode>
//        <StyledThemeProvider theme={theme}>
//            <NCMapViewerApp />
//        </StyledThemeProvider>
//    </React.StrictMode>,
//);